import React, { FC } from 'react';
import { Icon, TIconNames } from 'components/Icon';
import { ReactComponent as Workfeed } from 'assets/images/navIcons/workfeed.svg';
import { ReactComponent as Tickets } from 'assets/images/navIcons/tickets.svg';
import { ReactComponent as Tasks } from 'assets/images/navIcons/tasks.svg';
import { ReactComponent as Customers } from 'assets/images/navIcons/customers.svg';
import { ReactComponent as Timesheet } from 'assets/images/navIcons/timesheet.svg';
import { ReactComponent as TimeEntries } from 'assets/images/navIcons/timeEntries.svg';
import { ReactComponent as Projects } from 'assets/images/navIcons/projects.svg';
import { ReactComponent as Reports } from 'assets/images/navIcons/reports.svg';
import { ReactComponent as TeamManagement } from 'assets/images/navIcons/teamManagement.svg';
import { ReactComponent as Invoices } from 'assets/images/navIcons/invoices.svg';
import { ReactComponent as Configurations } from 'assets/images/navIcons/configurations.svg';
import { ReactComponent as Integrations } from 'assets/images/navIcons/integrations.svg';
import { ReactComponent as Help } from 'assets/images/navIcons/help.svg';
import { ReactComponent as Contacts } from 'assets/images/navIcons/contacts.svg';
import { ReactComponent as Companies } from 'assets/images/navIcons/companies.svg';
import { ReactComponent as Devices } from 'assets/images/navIcons/devices.svg';
import { ReactComponent as ItGoals } from 'assets/images/navIcons/itGoals.svg';
import { ReactComponent as Faq } from 'assets/images/navIcons/faq.svg';

/* ZEST-757: the side panel uses the redesign's outlined icons — stroked shapes
   with no fill, drawn in `currentColor` so they follow the sidebar's theme.
   The rest of the app still renders the icomoon set, so anything without an
   entry here falls back to it rather than disappearing. */
const navIcons: Partial<Record<TIconNames, FC<React.SVGProps<SVGSVGElement>>>> =
  {
    [TIconNames.DASHBOARD]: Workfeed,
    [TIconNames.TICKET]: Tickets,
    [TIconNames.TASK]: Tasks,
    [TIconNames.PEOPLE]: Customers,
    [TIconNames.CLOCK_FILLED]: Timesheet,
    [TIconNames.TIME_ENTRY]: TimeEntries,
    [TIconNames.LAPTOP]: Projects,
    [TIconNames.REPORT]: Reports,
    [TIconNames.MANAGEMENT]: TeamManagement,
    [TIconNames.GENERATE_INVOICE]: Invoices,
    [TIconNames.SETTINGS]: Configurations,
    [TIconNames.INTEGRATION]: Integrations,
    [TIconNames.INFO]: Help,
    [TIconNames.CONTACTS]: Contacts,
    [TIconNames.ORGANIZATION]: Companies,
    [TIconNames.DEVICE]: Devices,
    [TIconNames.IT_GOALS]: ItGoals,
    [TIconNames.FILE_DESCRIPTION]: Faq,
  };

type TNavIconProps = {
  icon: TIconNames;
  size?: number;
};

const NavIcon: FC<TNavIconProps> = ({ icon, size = 20 }) => {
  const Outlined = navIcons[icon];
  if (!Outlined) return <Icon size={size} icon={icon} />;
  return (
    <Outlined
      className="icon nav-icon"
      width={size}
      height={size}
      data-testid={`icon-${icon}`}
      aria-hidden
    />
  );
};

export default NavIcon;
